<template>
  <v-container class="pa-0">
    <div ref="chart">
      <div v-for="graph in graphs"
           :key="graph.id">
        <chart :datasets="graph.datasets"
               :bar-options="graph.barOptions"
               :height="chartHeight"></chart>
      </div>
    </div>
    <update-availabilities-modal :is-sensored="false"
                                 :parking-id="parkingId"
                                 :parking-name="parking.name"
                                 :is-availability-dialog-visible="isAvailabilityDialogVisible"
                                 @on-close-modal="closeModal"></update-availabilities-modal>
  </v-container>
</template>

<script>
import _ from 'lodash';
import store from '@/store';
import { chartsHelpers } from '@/components/commons/charts/chartsHelpers';
import Chart from '@/components/commons/charts/Chart.vue';
import UpdateAvailabilitiesModal from '@/components/commons/UpdateAvailabilitiesModal.vue';
import keys from '@/store/keys';
import { EventBus } from '@/services/eventBus';

const onCloseModalEvent = 'on-close-modal';
const onRefreshGraphsEvent = 'on-refresh-graphs';

export default {
  name: 'parking-availability-sensorless-graph',
  props: ['graphData', 'dates', 'isAvailabilityDialogVisible', 'parkingId', 'generalView'],
  components: {
    [Chart.name]: Chart,
    [UpdateAvailabilitiesModal.name]: UpdateAvailabilitiesModal
  },
  watch: {
    graphData: function(value) {
      this.updateGraph();
    },
    generalView: function(value) {
      this.updateGraph();
    }
  },
  data() {
    return {
      graphs: [],
      plotUnit: 'day',
      parking: {},
      spots: [],
      chartHeight: 600
    };
  },
  created() {
    this.parking = store.state.parkingSelected;
    this.spots = store.state.parkingSpots;
    EventBus.$on(keys.eventOnScreenSizeChanged, this.refreshGraph);

    let displaySize = chartsHelpers.getDisplaySize(this);

    if (displaySize === 'xs') {
      this.chartHeight = 600;
    } else {
      this.chartHeight = 250;
    }
  },
  destroyed() {
    EventBus.$off(keys.eventOnScreenSizeChanged, this.refreshGraph);
  },
  methods: {
    async refreshGraph(params) {
      if (params.to === 'xs') {
        this.chartHeight = 600;
      } else {
        this.chartHeight = 250;
      }
      if (typeof this.$refs.chart === 'undefined') {
        return;
      }
      this.$refs.chart.getElementsByTagName('canvas')[0].style.width = 0;
      await this.updateGraph();
    },
    updateGraph() {
      if (typeof this.graphData.chartData === 'undefined') {
        return;
      }
      if (this.graphData.chartData.length <= 0) {
        return;
      }
      this.graphs = [];

      this.plotUnit = chartsHelpers.getPlotUnit(this.dates[0], this.dates[1]);

      let barOptions = chartsHelpers.getAvailabilityDetailsParkingSensorlessBarOptions(this, this.graphData);

      let fillChartDataResults = chartsHelpers.fillChartData(this.graphData.chartSettings, this.graphData.chartData, this.dates[0], this.dates[1], false, this.generalView);

      let date = fillChartDataResults.date;
      let dataSetsArray = fillChartDataResults.dataSetsArray;

      let datasets = {
        labels: date,
        datasets: dataSetsArray
      };

      this.graphs.push({
        datasets: datasets,
        barOptions: barOptions,
        id: _.uniqueId()
      });
    },
    closeModal() {
      this.$emit(onCloseModalEvent);
    },
    updateGraphs() {
      this.$emit(onRefreshGraphsEvent);
    }
  }
};
</script>

<style lang="scss" scoped>
.panel .panel-heading .panel-title {
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 0;
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/commons/ParkingAvailabilitySensorlessGraph.vue